/* eslint-disable no-sparse-arrays */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import * as listingManagementActions from '~actions/pms-actions/properties/listing-management';
import HomepageCard from '~pages/pms-dashboard/properties/homepage/homepage-card';
import generatePath from '~settings/routing';
import Header from '~components/property-header';
import { Spin, Icon, Tooltip, Typography } from 'antd';
import { communicationStatus, platformEntity, entityAction } from '~constants';
import showElementByAuth from '~helpers/auth';
import { isEmptyObject } from '~helpers/property-edit';
import PendingAlertTips from '~components/pending-alert-tips';
import BookingJourneyStructures from './booking-journey-structures';
import { trackViewPropertyHomePage, trackClickPropertyHomePage } from '../track';

const { Paragraph } = Typography;
const mapStateToProps = state => {
  const propertyData = state.pmsReducer.dashboard.listingManagement.toJS();

  return {
    property: propertyData.payload,
    getPropertyStatus: propertyData.communication.getDetail.status,
  };
};

const mapDispatchToProps = dispatch => ({
  getPropertyDetail: (id, successCallback) => {
    dispatch(listingManagementActions.getPropertyDetail(id, successCallback));
  },
});

@connect(mapStateToProps, mapDispatchToProps)
@withTranslation()
export default class PropertyHomepage extends React.Component {
  constructor() {
    super();
    this.propertyManagement = [
      'listing_management',
      'terms',
      'stage_record',
      'commission_management',
      // 'deposit_and_fees',
      ,
      ,
    ];
    this.homepageFirstApart = ['listing_management', 'terms'];
    this.homepageSecondApart = ['stage_record', 'commission_management'];
    this.functionEntityMapping = {
      listing_management: platformEntity.PROPERTIES_PROPERTIES,
      commission_management: platformEntity.COMMISSION_COMISSION_TIERS,
      // deposit_and_fees: platformEntity.PAYMENTS_LINE_ITEM_RULES,
      stage_record: platformEntity.PROPERTIES_PROPERTIES_CONTRACTS,
      terms: platformEntity.PROPERTIES_TERMS,
    };
  }

  componentDidMount() {
    this.props.getPropertyDetail(decodeURIComponent(this.props.match.params.propertySlug), () => {
      if (isEmptyObject(this.props.property)) {
        this.props.history.push(generatePath('properties', {}));
      }

      trackViewPropertyHomePage(this.props.property);
    });
  }

  componentDidUpdate(preProp) {
    if (preProp.match.params.propertySlug !== this.props.match.params.propertySlug) {
      this.props.getPropertyDetail(decodeURIComponent(this.props.match.params.propertySlug), () => {
        trackViewPropertyHomePage(this.props.property);
      });
    }
  }

  redirectToEditPage = item => {
    let url = null;
    let position = null;
    const { propertySlug } = this.props.match.params;

    if (item === 'listing_management') {
      url = generatePath('property.edit', { propertySlug });
      position = 'Property Management';
    }

    if (item === 'commission_management') {
      url = generatePath('property.commission', { propertySlug });
      position = 'View Commission';
    }

    if (item === 'stage_record') {
      url = generatePath('property.record', { propertySlug });
      position = 'View Contract';
    }

    if (item === 'deposit_and_fees') {
      url = generatePath('property.depositAndFees', { propertySlug });
      position = '';
    }

    if (item === 'terms') {
      url = generatePath('property.terms', { propertySlug });
      position = 'Property Terms';
    }

    position && trackClickPropertyHomePage(position, this.props.property);
    url && this.props.history.push(url);
  };

  homepageContent = ({ title, contentArr }) => {
    return (
      <>
        <h2 className="property-homepage__title">{this.props.t(title)}</h2>
        <For of={contentArr} each="item" index="index">
          <If
            condition={
              this.functionEntityMapping[item]
                ? showElementByAuth(this.functionEntityMapping[item], entityAction.READ)
                : true
            }
            key={item}
          >
            <button
              className={classNames('property-homepage__link', {
                'property-homepage__link--even': index % 2 === 0,
              })}
              onClick={() => {
                this.redirectToEditPage(item);
              }}
              key={item}
            >
              <HomepageCard t={this.props.t} type={item} />
            </button>
          </If>
        </For>
      </>
    );
  };
  sourceSystemContent = {
    integration: 'API integration',
    salesforce: 'Salesforce',

    entrata: 'Entrata ILS',

    platform_gateway: 'Platform',

    public_gateway: 'Open API',

    cms_facade: '-',
  };

  render() {
    const { t, property, getPropertyStatus } = this.props;
    const BookingJourneyTypes = {
      SEMI_AUTOMATIC: 'hercules',
      FULL_AUTOMATIC: 'yugo',
      MANUAL: 'booked',
      INSTANT_BOOK: 'instant',
      LEAD_GENERATION: 'lead_generation',
    };
    return (
      <div className="property-homepage">
        <Choose>
          <When condition={getPropertyStatus !== communicationStatus.IDLE}>
            <div className="property-edit__loading">
              <Spin />
            </div>
          </When>
          <Otherwise>
            <Header t={t} property={property} type="homepage" />
            <div className="property-homepage__booktype">
              <span>{t('cms:Properties_page_homepage_book_type')}:</span>

              <span className="property-homepage__bookingJourney">
                {t(`cms:properties_booking_type_${property?.bookingJourney?.toLowerCase()}`)}
              </span>

              <BookingJourneyStructures type={BookingJourneyTypes[property?.bookingJourney]}>
                <button className="property-homepage__question-answer">
                  <Icon type="question-circle" className="property-homepage__hit-svg" />
                </button>
              </BookingJourneyStructures>
              <span className="property-homepage__property-source">
                {t('cms:property.detail.property_source')}:
              </span>
              <If condition={property?.externalId}>
                <If condition={property?.externalSystem}>
                  <span className="property-homepage__external-content">
                    {`${this.sourceSystemContent[property?.externalSystem?.toLowerCase()]}, `}
                  </span>
                  <span
                    className="property-homepage__externalId"
                    style={{ verticalAlign: 'middle' }}
                  >
                    <If condition={property?.externalId?.length > 10}>
                      <Tooltip title={property?.externalId}>
                        <span>{`${property?.externalId?.slice(0, 10)}...`}</span>
                      </Tooltip>
                    </If>
                    <If condition={property?.externalId?.length <= 10}>
                      <span>{property?.externalId}</span>
                    </If>
                  </span>
                  <span style={{ display: 'inline-block' }}>
                    <Paragraph copyable={{ text: property?.externalId }} />
                  </span>
                </If>
                <If condition={!property?.externalSystem}>
                  <span className="property-homepage__external-content">-</span>
                </If>
              </If>
              <If condition={!property?.externalId}>
                <span className="property-homepage__external-content">
                  {property?.externalSystem
                    ? `${this.sourceSystemContent[property?.externalSystem?.toLowerCase()]}`
                    : '-'}
                </span>
              </If>
            </div>
            <div className="property-homepage__content">
              <If condition={property}>
                <PendingAlertTips
                  from="propertyHomepage"
                  property={property}
                  history={this.props.history}
                />
              </If>
              {this.homepageContent({
                title: 'cms:cms.properties.homepage.property_management.title',
                contentArr: this.homepageFirstApart,
              })}
              {this.homepageContent({
                title: 'cms:Properties_page_homepage_Settings_title',
                contentArr: this.homepageSecondApart,
              })}
              <div className="property-homepage__clear-both" />
            </div>
          </Otherwise>
        </Choose>
      </div>
    );
  }
}

PropertyHomepage.propTypes = {
  t: PropTypes.func.isRequired,
  match: PropTypes.object,
  history: PropTypes.object.isRequired,
  getPropertyDetail: PropTypes.func,
  property: PropTypes.object,
  getPropertyStatus: PropTypes.string,
};

PropertyHomepage.defaultProps = {
  t: () => {},
  match: {},
  getPropertyDetail: () => {},
  property: {},
  getPropertyStatus: '',
};
